var _circle, _g, _g2, _g3, _circle2, _g4, _circle3, _circle4, _path, _path2, _g5, _rect, _rect2, _rect3, _rect4, _g6, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDogumGunuGift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 360,
    viewBox: "0 0 400 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_11448",
    "data-name": "Group 11448",
    transform: "translate(486.811 -1528.339)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2872",
    "data-name": "Ellipse 2872",
    cx: 180,
    cy: 180,
    r: 180,
    transform: "translate(-467.811 1888.339) rotate(-90)",
    fill: "#fde3a7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11434",
    "data-name": "Group 11434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9495",
    "data-name": "Path 9495",
    d: "M-216.921,1788.6a6.474,6.474,0,0,0-6.474,6.474v.743H-346.226v-.743a6.474,6.474,0,0,0-6.474-6.474h-96q3.606,7.413,7.857,14.434h37.4a10.844,10.844,0,0,0-.3,2.519c0,5.355,3.866,9.737,8.59,9.737h186.377c4.724,0,8.589-4.382,8.589-9.737a10.845,10.845,0,0,0-.3-2.519h65.723q4.249-7.013,7.858-14.434Z",
    fill: "#ffcd29"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11436",
    "data-name": "Group 11436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11435",
    "data-name": "Group 11435"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9496",
    "data-name": "Path 9496",
    d: "M-204.907,1614.354a2.338,2.338,0,0,1-2.337-2.337c0-1.187-.608-1.774-2.218-3.031-1.694-1.323-4.013-3.137-4.013-6.712s2.319-5.388,4.013-6.712c1.61-1.258,2.218-1.845,2.218-3.029s-.608-1.767-2.218-3.024c-1.694-1.324-4.013-3.137-4.013-6.711s2.319-5.383,4.013-6.7c1.61-1.255,2.218-1.841,2.218-3.022a2.337,2.337,0,0,1,2.337-2.336,2.337,2.337,0,0,1,2.337,2.336c0,3.572-2.322,5.384-4.016,6.706-1.607,1.255-2.215,1.841-2.215,3.021s.608,1.77,2.218,3.028c1.691,1.322,4.013,3.134,4.013,6.707s-2.322,5.387-4.013,6.711c-1.61,1.258-2.218,1.845-2.218,3.03s.608,1.772,2.218,3.03c1.691,1.324,4.013,3.137,4.013,6.713a2.338,2.338,0,0,1-2.337,2.337Z",
    fill: "#f8aca7"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11438",
    "data-name": "Group 11438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11437",
    "data-name": "Group 11437"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9497",
    "data-name": "Path 9497",
    d: "M-365.187,1539.111a2.338,2.338,0,0,1,2.337,2.337c0,1.185.608,1.772,2.218,3.03,1.691,1.324,4.013,3.137,4.013,6.712s-2.322,5.389-4.013,6.712c-1.61,1.258-2.218,1.846-2.218,3.029s.608,1.768,2.215,3.024c1.694,1.324,4.016,3.137,4.016,6.711s-2.322,5.384-4.016,6.706c-1.607,1.255-2.215,1.84-2.215,3.021a2.338,2.338,0,0,1-2.337,2.337,2.338,2.338,0,0,1-2.337-2.337c0-3.572,2.319-5.384,4.013-6.706,1.61-1.255,2.218-1.841,2.218-3.021s-.608-1.769-2.218-3.028c-1.694-1.322-4.013-3.133-4.013-6.707s2.319-5.387,4.013-6.71c1.61-1.258,2.218-1.846,2.218-3.031s-.608-1.772-2.218-3.03c-1.694-1.324-4.013-3.137-4.013-6.712a2.338,2.338,0,0,1,2.337-2.337Z",
    fill: "#ffbc00"
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2873",
    "data-name": "Ellipse 2873",
    cx: 4.868,
    cy: 4.868,
    r: 4.868,
    transform: "translate(-267.618 1560.92)",
    fill: "#ffbc00"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11439",
    "data-name": "Group 11439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9498",
    "data-name": "Path 9498",
    d: "M-300.565,1834.841a2.337,2.337,0,0,1,2.337,2.337c0,1.185.608,1.772,2.218,3.03,1.7,1.324,4.013,3.137,4.013,6.712s-2.318,5.388-4.013,6.712c-1.61,1.258-2.218,1.845-2.218,3.029s.608,1.768,2.218,3.024c1.7,1.324,4.013,3.137,4.013,6.711s-2.318,5.383-4.013,6.7c-1.61,1.256-2.218,1.841-2.218,3.022a2.337,2.337,0,0,1-2.337,2.336,2.337,2.337,0,0,1-2.337-2.336c0-3.572,2.322-5.384,4.017-6.706,1.606-1.255,2.215-1.841,2.215-3.021s-.609-1.77-2.218-3.028c-1.692-1.322-4.014-3.134-4.014-6.707s2.322-5.387,4.014-6.711c1.609-1.258,2.218-1.845,2.218-3.03s-.609-1.772-2.218-3.03c-1.692-1.324-4.014-3.137-4.014-6.712a2.337,2.337,0,0,1,2.337-2.337Z",
    fill: "#f8aca7"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2874",
    "data-name": "Ellipse 2874",
    cx: 4.868,
    cy: 4.868,
    r: 4.868,
    transform: "translate(-372.392 1834.841)",
    fill: "#f8aca7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2875",
    "data-name": "Ellipse 2875",
    cx: 4.868,
    cy: 4.868,
    r: 4.868,
    transform: "translate(-201.64 1825.105)",
    fill: "#ffbc00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11447",
    "data-name": "Group 11447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11441",
    "data-name": "Group 11441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11440",
    "data-name": "Group 11440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9499",
    "data-name": "Path 9499",
    d: "M-162.95,1665.094a27.213,27.213,0,0,0-38.552,0,27.377,27.377,0,0,0,0,38.649c10.646,10.676,46.536,8,46.536,8S-152.3,1675.767-162.95,1665.094Zm-26.711,26.781C-200.31,1681.2-194.62,1672-194.62,1672s4.041-.549,14.687,10.124,15.057,24.657,15.057,24.657S-179.015,1702.545-189.661,1691.875Z",
    fill: "#004990",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9500",
    "data-name": "Path 9500",
    d: "M-108.427,1665.094a27.213,27.213,0,0,0-38.552,0c-10.649,10.673-7.987,46.653-7.987,46.653s35.893,2.672,46.539-8A27.377,27.377,0,0,0-108.427,1665.094Zm-11.841,26.781c-10.646,10.67-24.6,15.092-24.6,15.092s4.223-14.174,14.869-24.846,19.826-4.969,19.826-4.969S-109.622,1681.2-120.268,1691.875Z",
    fill: "#003169",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2876",
    "data-name": "Ellipse 2876",
    cx: 16.357,
    cy: 16.398,
    rx: 16.357,
    ry: 16.398,
    transform: "translate(-171.323 1700.788)",
    fill: "#004990",
    style: {
      isolation: "isolate"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9501",
    "data-name": "Path 9501",
    d: "M-91.484,1717.186h-34.272v78.085h34.272a4.692,4.692,0,0,0,4.673-4.686v-68.714A4.691,4.691,0,0,0-91.484,1717.186Z",
    fill: "#0089d9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9502",
    "data-name": "Path 9502",
    d: "M-218.445,1717.186a4.691,4.691,0,0,0-4.673,4.685v68.714a4.692,4.692,0,0,0,4.673,4.686h92.689v-78.085Z",
    fill: "#00a8ff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10047",
    "data-name": "Rectangle 10047",
    width: 38.945,
    height: 15.617,
    transform: "translate(-125.756 1753.105)",
    fill: "#001d42",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10048",
    "data-name": "Rectangle 10048",
    width: 6.231,
    height: 78.085,
    transform: "translate(-106.283 1717.186)",
    fill: "#001d42",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10049",
    "data-name": "Rectangle 10049",
    width: 97.363,
    height: 15.617,
    transform: "translate(-223.118 1753.105)",
    fill: "#003169",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10050",
    "data-name": "Rectangle 10050",
    width: 15.578,
    height: 78.085,
    transform: "translate(-185.342 1717.186)",
    fill: "#004990",
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11443",
    "data-name": "Group 11443"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11442",
    "data-name": "Group 11442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9503",
    "data-name": "Path 9503",
    d: "M-434.1,1659.958a19.442,19.442,0,0,0-27.539,0,19.56,19.56,0,0,0,0,27.608c7.605,7.625,33.242,5.719,33.242,5.719S-426.491,1667.584-434.1,1659.958Zm-19.08,19.128c-7.6-7.622-3.54-14.2-3.54-14.2s2.884-.394,10.489,7.232a48.864,48.864,0,0,1,10.754,17.611A47.273,47.273,0,0,1-453.176,1679.086Z",
    fill: "#7ae0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9504",
    "data-name": "Path 9504",
    d: "M-395.151,1659.958a19.442,19.442,0,0,0-27.539,0c-7.6,7.626-5.7,33.327-5.7,33.327s25.638,1.906,33.242-5.719A19.556,19.556,0,0,0-395.151,1659.958Zm-8.458,19.128a48.7,48.7,0,0,1-17.57,10.783,47.427,47.427,0,0,1,10.622-17.746c7.605-7.626,14.161-3.551,14.161-3.551S-396.005,1671.464-403.609,1679.086Z",
    fill: "#29bfff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2877",
    "data-name": "Ellipse 2877",
    cx: 11.684,
    cy: 11.713,
    rx: 11.684,
    ry: 11.713,
    transform: "translate(-440.076 1685.455)",
    fill: "#7ae0ff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9505",
    "data-name": "Path 9505",
    d: "M-374.649,1697.168H-408.92v97.606h34.271a4.693,4.693,0,0,0,4.674-4.685v-88.236A4.692,4.692,0,0,0-374.649,1697.168Z",
    fill: "#003169",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9506",
    "data-name": "Path 9506",
    d: "M-482.137,1697.168a4.692,4.692,0,0,0-4.674,4.685v88.236a4.693,4.693,0,0,0,4.674,4.685h73.217v-97.606Z",
    fill: "#004990",
    style: {
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10051",
    "data-name": "Rectangle 10051",
    width: 38.945,
    height: 15.617,
    transform: "translate(-408.92 1747.923)",
    fill: "#29bfff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10052",
    "data-name": "Rectangle 10052",
    width: 6.231,
    height: 97.606,
    transform: "translate(-389.448 1697.168)",
    fill: "#6d2e66"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10053",
    "data-name": "Rectangle 10053",
    width: 77.89,
    height: 15.617,
    transform: "translate(-486.811 1747.923)",
    fill: "#7ae0ff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10054",
    "data-name": "Rectangle 10054",
    width: 15.578,
    height: 97.606,
    transform: "translate(-455.654 1697.168)",
    fill: "#a3edff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11446",
    "data-name": "Group 11446"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11444",
    "data-name": "Group 11444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9507",
    "data-name": "Path 9507",
    d: "M-314.9,1616.344a27.211,27.211,0,0,0-38.552,0,27.377,27.377,0,0,0,0,38.649c10.646,10.675,46.536,8,46.536,8S-304.255,1627.016-314.9,1616.344Zm-26.711,26.781c-10.649-10.676-4.959-19.879-4.959-19.879s4.041-.549,14.687,10.124,15.057,24.658,15.057,24.658S-330.966,1653.794-341.612,1643.125Z",
    fill: "#ffdc52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9508",
    "data-name": "Path 9508",
    d: "M-260.378,1616.344a27.211,27.211,0,0,0-38.552,0c-10.649,10.672-7.987,46.653-7.987,46.653s35.893,2.671,46.539-8A27.377,27.377,0,0,0-260.378,1616.344Zm-11.841,26.781c-10.646,10.669-24.6,15.092-24.6,15.092s4.223-14.174,14.869-24.847,19.826-4.969,19.826-4.969S-261.573,1632.449-272.219,1643.125Z",
    fill: "#ffbc00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2878",
    "data-name": "Ellipse 2878",
    cx: 16.357,
    cy: 16.398,
    rx: 16.357,
    ry: 16.398,
    transform: "translate(-323.274 1652.037)",
    fill: "#ffdc52"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11445",
    "data-name": "Group 11445"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9509",
    "data-name": "Path 9509",
    d: "M-271.259,1804.339h53.745a4.693,4.693,0,0,0,4.673-4.685V1672.376a4.678,4.678,0,0,0-4.673-4.685h-53.745Z",
    fill: "#e60900",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9510",
    "data-name": "Path 9510",
    d: "M-251.786,1804.339V1672.376a4.679,4.679,0,0,0-4.674-4.685H-383.421a4.678,4.678,0,0,0-4.673,4.685v127.278a4.693,4.693,0,0,0,4.673,4.685Z",
    fill: "#f23427",
    style: {
      isolation: "isolate"
    }
  }), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10055",
    "data-name": "Rectangle 10055",
    width: 38.945,
    height: 19.521,
    transform: "translate(-251.786 1731.135)",
    fill: "#d99800"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10056",
    "data-name": "Rectangle 10056",
    width: 136.308,
    height: 19.521,
    transform: "translate(-388.094 1731.135)",
    fill: "#ffcd29"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10057",
    "data-name": "Rectangle 10057",
    width: 19.473,
    height: 136.649,
    transform: "translate(-332.792 1667.691)",
    fill: "#ffdc52"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10058",
    "data-name": "Rectangle 10058",
    width: 6.231,
    height: 136.649,
    transform: "translate(-232.314 1667.691)",
    fill: "#d99800"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogumGunuGift);
export default __webpack_public_path__ + "static/media/dogum-gunu-gift.80cd260905a8ab4bfcc4d03ac38c21f7.svg";
export { ForwardRef as ReactComponent };